exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu[data-v-34500320]{position:fixed;background:#fff;min-width:120px;border-radius:4px;border:1px solid #e6ebf5;padding:12px;z-index:9999;color:#606266;line-height:1.5;text-align:justify;font-size:13px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,0.1);box-shadow:0 2px 12px 0 rgba(0,0,0,0.1);word-break:break-all}\n", ""]);

// exports
